// Import our custom CSS
import '../scss/theme.scss'

// import Swiper bundle with all modules installed
//import Swiper from 'swiper/bundle';
// import styles bundle
//import 'swiper/css/bundle';

// Import all of Bootstrap's JS
//import * as bootstrap from 'bootstrap'

/* import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel' */

// opzionale: importa i css (se non gestiti separatamente)
/* import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'; */

jQuery(function ($) {
    /* function initSlick(selector) {
        const slider = $(selector + ' ul.products');
        if (slider.length && !slider.hasClass('slick-initialized')) {
            slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true,
                arrows: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: 480,
                        settings: { slidesToShow: 1 }
                    }
                ]
            });
        }
    }

    initSlick('.related.products');
    initSlick('.upsells.products'); */

    $('.woocommerce-product-gallery__image a').on('click', (e) => {
        e.preventDefault();
    });

}); // jQuery End

document.addEventListener("DOMContentLoaded", (event) => {

    document.querySelectorAll(".scroll-link").forEach(function (link) {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            const scroll = 400;
            if (window.scrollY < scroll) {
                window.scrollBy({
                    top: scroll,
                    left: 0,
                    behavior: "smooth"
                });
            }
        });
    });

    // Faq
    if (document.querySelectorAll('.faq-button').length > 0) {
        const faqButtons = document.querySelectorAll('.faq-button');
        const classActive = 'faq-text-active';

        faqButtons.forEach(button => {
            button.addEventListener('click', () => {
                const currentlyActive = document.querySelector('.' + classActive);
                const targetElement = button.nextElementSibling;

                // Chiudi l'elemento attivo, se presente e diverso da quello cliccato
                if (currentlyActive && currentlyActive !== targetElement) {
                    currentlyActive.classList.remove(classActive);
                }

                // Se l'elemento cliccato è già attivo, chiudilo
                if (targetElement.classList.contains(classActive)) {
                    targetElement.classList.remove(classActive);
                } else {
                    // Altrimenti aprilo
                    targetElement.classList.add(classActive);
                }
            });
        });
    }

    if (document.querySelectorAll('.faq-tab-button').length > 0) {
        const faqTabButtons = document.querySelectorAll('.faq-tab-button');
        const activeTabClassBtn = 'faq-active';
        const activeTabClass = 'faq-list-active';

        faqTabButtons.forEach(tabButton => {
            tabButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (!tabButton.classList.contains(activeTabClassBtn)) {
                    document.querySelector('.' + activeTabClassBtn).classList.remove(activeTabClassBtn);
                    document.querySelector('.' + activeTabClass).classList.remove(activeTabClass);

                    document.querySelector(tabButton.getAttribute('href')).classList.add(activeTabClass);
                    tabButton.classList.add(activeTabClassBtn);
                }
            });
        });
    }

}); // Javascript end